module.exports = __webpack_public_path__ + "static/img/C4D0024.47c9f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0024.jpg
// module id = 5/KC
// module chunks = 0